import { Helmet } from "react-helmet-async";
import { Layout } from "@/components/layout/Layout";
import { useBusinessSettings } from "@/hooks/useBusinessSettings";

const Privacy = () => {
  const { getSetting } = useBusinessSettings();
  const email = getSetting("email");

  return (
    <>
      <Helmet><title>Privacy Policy - Pixie Clicks</title></Helmet>
      <Layout>
        <section className="section-padding">
          <div className="container-narrow prose prose-lg max-w-none">
            <h1 className="font-serif text-4xl font-semibold text-foreground">Privacy Policy</h1>
            <p className="text-muted-foreground mt-6">Last updated: December 2024</p>
            <h2 className="font-serif text-2xl mt-8">Information We Collect</h2>
            <p className="text-muted-foreground">We collect information you provide directly, including name, email, phone number, and wedding details when you contact us or book our services.</p>
            <h2 className="font-serif text-2xl mt-8">How We Use Your Information</h2>
            <p className="text-muted-foreground">We use your information to provide our photography services, communicate with you, and improve our offerings.</p>
            <h2 className="font-serif text-2xl mt-8">Contact</h2>
            <p className="text-muted-foreground">Questions? Email us at <a href={`mailto:${email}`} className="text-primary hover:underline">{email}</a></p>
          </div>
        </section>
      </Layout>
    </>
  );
};

export default Privacy;
